/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React, { useEffect, useState } from 'react';
import {
  Link,
  useParams,
  useNavigate,
  useLocation,
  useOutletContext
} from 'react-router-dom';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import { selectUser } from '../../store/userSlice';
// Actions
import {
  approveComment,
  unapproveComment,
  publishComment,
  unpublishComment
} from '../comments/actions';
// BASE Components
import BASESvgIcon from '../../../@BASE/core/BASESvgIcon';
import BASELoading from '../../../@BASE/core/BASELoading';
import NavLinkAdapter from '../../../@BASE/core/NavLinkAdapter';
// Material UI Components
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
// Custom Components
import IMICommentList from '../../shared-components/comments/IMICommentList';
import _ from '../../../@lodash';
import moment from 'moment';
import authRoles from '../../auth/authRoles';

function PageComments(props) {
  const { instance, reviews, setCommentsUpdated } = props;
  const user = useSelector(selectUser);
  const routeParams = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleApproveComment = (comment) => {
    dispatch(approveComment(comment)).then(({ payload }) => {
      setCommentsUpdated(true);
      navigate(`/imi-comments/pages/${routeParams.id}`, { replace: true });
    });
  };

  const handleUnapproveComment = (comment) => {
    dispatch(unapproveComment(comment)).then(({ payload }) => {
      setCommentsUpdated(true);
      navigate(`/imi-comments/pages/${routeParams.id}`, { replace: true });
    });
  };

  const handlePublishComment = (comment) => {
    dispatch(publishComment(comment)).then(({ payload }) => {
      setCommentsUpdated(true);
      navigate(`/imi-comments/pages/${routeParams.id}`);
    });
  };

  const handleUnpublishComment = (comment) => {
    dispatch(unpublishComment(comment)).then(({ payload }) => {
      setCommentsUpdated(true);
      navigate(`/imi-comments/pages/${routeParams.id}`);
    });
  };

  if (!instance) {
    return <BASELoading />;
  }

  return (
    <div className="relative my-64">
      <div className="flex flex-row h-64 items-center justify-between w-full pl-16">
        <Typography className="text-20 font-bold leading-none">
          Comments
        </Typography>
      </div>

      {/* <div className="w-full px-16 py-20">
        <Button
          to={`/lessons/${instance?.section?.lesson?.id}/comments`}
          component={Link}
          className="mb-0"
          color="secondary"
          variant="text"
          startIcon={
            <BASESvgIcon size={20}>
              heroicons-outline:external-link
            </BASESvgIcon>
          }
        >
          View Lesson Comments
        </Button>
        
      </div> */}

      <div className="relative flex flex-col flex-auto px-0">
        {/* <Typography className="mt-12 text-2xl font-bold truncate">
          Comments
        </Typography>
        <Divider className="mt-16 mb-24" /> */}

        <IMICommentList
          comment_category="pages"
          simple_list
          instance={instance}
        />
      </div>

      <Box
        className="flex justify-between items-center mt-40 p-16 border-t w-full bottom-0 z-9999"
        sx={{
          backgroundColor: 'background.default',
          width: 384
        }}
      >
        <Tooltip title="View All Comments" arrow>
          <Button
            to={`/lessons/${instance?.section?.lesson?.id}/imi-comments`}
            component={Link}
            className="mb-0"
            variant="outlined"
            startIcon={
              <BASESvgIcon size={20}>heroicons-outline:external-link</BASESvgIcon>
            }
          >
            All Comments
          </Button>
        </Tooltip>
        <Tooltip title="Add Comment" arrow>
          <Button
            className="ml-8"
            variant="contained"
            color="secondary"
            component={NavLinkAdapter}
            to="comments/new/edit"
            startIcon={<BASESvgIcon size={20}>heroicons-outline:plus</BASESvgIcon>}
          >
            Comment
          </Button>
        </Tooltip>
      </Box>
    </div>
  );
}

export default PageComments;
